export enum RequestStatus {
  Initial = "initial",
  Pending = "pending",
  Success = "success",
  Error = "error",
}
